// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-icon[data-v-f2cbb5da]{transform:rotate(-45deg);transform-origin:50% 50%;border-radius:50% 50% 50% 0;padding:0 3px 3px 0;width:38px;height:38px;display:flex;align-items:center;justify-content:center;border:2px solid #fff;box-shadow:-1px 1px 4px rgba(0,0,0,.5)}.icon-content[data-v-f2cbb5da]{margin-top:4px;transform:rotate(45deg)}.map-icon img[data-v-f2cbb5da]{width:20px;height:20px}", ""]);
// Exports
module.exports = exports;
